import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=118d1406&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=118d1406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d1406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118d1406')) {
      api.createRecord('118d1406', component.options)
    } else {
      api.reload('118d1406', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=118d1406&scoped=true&", function () {
      api.rerender('118d1406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/peddler-management/Detail.vue"
export default component.exports